import axios, { AxiosError } from 'axios';
const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/agentesseguridad';

export interface AgenteSeguridad {
    Id: number;
    Name: string;
    NIP: string;
    Status: 'active' | 'inactive';
    CreatedDate?: string;
    LastModifiedDate?: string;
}

const extraerError = (error: unknown, fallback: string) => {
    const axiosError = error as AxiosError;
    return (axiosError.response?.data as any)?.error || fallback;
};

const agentesSeguridadApi = {
    listado: async (): Promise<AgenteSeguridad[]> => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`);
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error('Error obteniendo agentes de seguridad:', error);
            return [];
        }
    },

    crear: async (data: { Name: string; NIP: string }, solicitanteId: number) => {
        try {
            const response = await axios.post(`${BASE_URL}/crear`, { ...data, solicitanteId });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extraerError(error, 'No se pudo crear el agente') };
        }
    },

    editar: async (id: number, data: { Name: string; NIP: string }, solicitanteId: number) => {
        try {
            const response = await axios.put(`${BASE_URL}/editar/${id}`, { ...data, solicitanteId });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extraerError(error, 'No se pudo editar el agente') };
        }
    },

    baja: async (id: number, solicitanteId: number) => {
        try {
            await axios.put(`${BASE_URL}/baja/${id}`, { solicitanteId });
            return { success: true };
        } catch (error) {
            return { success: false, error: extraerError(error, 'No se pudo desactivar el agente') };
        }
    },

    reactivar: async (id: number, solicitanteId: number) => {
        try {
            await axios.put(`${BASE_URL}/reactivar/${id}`, { solicitanteId });
            return { success: true };
        } catch (error) {
            return { success: false, error: extraerError(error, 'No se pudo reactivar el agente') };
        }
    },
};

export default agentesSeguridadApi;
